import type {InjectionKey} from "vue";
import type JobApiProvider from "./JobApiProvider.ts";


export const KeyJobApiProvider = Symbol() as InjectionKey<JobApiProvider>;
